import React from "react";
import { useQuery } from "@apollo/client";
import { FrequentSearch } from "../../../../property/src/sections/frequent-search/component/FrequentSearch";
import { SEARCH_FACETS_QUERY } from "../../facets/queries";
import { cleanName } from "@coninsa-site/project/src/utils";

export function ProjectFrequentSearch() {
  const { data } = useQuery(SEARCH_FACETS_QUERY);
  
  if (!data) {
    return null;
  }

  const list = data.search.facets[0].values as Array<{
    count: number;
    filter: string;
  }>;

  const formattedList = list.map((item) => {
    return {
      id: item.filter,
      label: `Conoce los proyectos que tenemos para ti en ${item.filter}`,
      path: `/proyectos/nuevo/region/${cleanName(item.filter)}`,
      title: `Conoce los proyectos que tenemos para ti en ${item.filter}`,
    };
  });

  return <FrequentSearch list={formattedList} />;
}
